import { BaseMutationTypes } from '../BaseMutationTypes';

export class WorkflowJobMutationTypes extends BaseMutationTypes {
  public static readonly SetIsDirty = 'SET_IS_DIRTY';
  public static readonly SetErrorMessage = 'SET_ERROR_MESSAGE';
  public static readonly SetIsWorkflowJobLocked = 'SET_IS_WORKFLOW_JOB_LOCKED';
  public static readonly WorkflowJobLoaded = 'WORKFLOW_JOB_LOADED';
  public static readonly WorkflowJobError = 'WORKFLOW_JOB_ERROR';
  public static readonly PopulateHorizontalJobTabStates = 'POPULATE_HORIZONTAL_JOB_TAB_STATES';
  public static readonly PopulateVerticalJobTabStates = 'POPULATE_VERTICAL_JOB_TAB_STATES';
  public static readonly SetJobTabStateCount = 'SET_JOB_TAB_STATE_COUNT';
  public static readonly SetJobTabStateDirty = 'SET_JOB_TAB_STATE_DIRTY';
  public static readonly SetJobTabStateHidden = 'SET_JOB_TAB_STATE_HIDDEN';
  public static readonly UpdateWorkflowDataSourceField = 'UPDATE_WORKFLOW_DATA_SOURCE_FIELD';
  public static readonly SetDynamicFields = 'SET_DYNAMIC_FIELDS';
  public static readonly SetActiveHorizontalTab = 'SET_ACTIVE_HORIZONTAL_TAB';
  public static readonly SetActiveVerticalTab = 'SET_ACTIVE_VERTICAL_TAB';
  public static readonly SetExtendingWorkflowJobLock = 'SET_EXTENDING_WORKFLOW_JOB_LOCK';
  public static readonly ExtendWorkflowJobLock = 'EXTEND_WORKFLOW_JOB_LOCK';
  public static readonly ExpireWorkflowJobLock = 'EXPIRE_WORKFLOW_JOB_LOCK';
  public static readonly SetComponentName = 'SET_JOB_COMPONENT_NAME';
  public static readonly SetErrorModel = 'SET_JOB_ERROR_MODEL';
  public static readonly SetDynamicFormValidationModel = 'SET_DYNAMIC_FORM_VALIDATION_MODEL';
  public static readonly UnloadWorkflowJob = 'UNLOAD_WORKFLOW_JOB';
  public static readonly AddDynamicFormModelToCustomJobTab = 'ADD_DYNAMIC_FORM_MODEL_TO_CUSTOM_JOB_TAB';
  public static readonly SetIsAwaitingProcessing = 'SET_IS_AWAITING_PROCESSING';
  public static readonly InvalidateAllDynamicForms = 'INVALIDATE_ALL_DYNAMIC_FORMS';
  public static readonly SetPostProcessNavigation = 'SET_POST_PROCESS_NAVIGATION';
  public static readonly SetIsTabProcessing = 'SET_IS_TAB_PROCESSING';
  public static readonly SetHasWorkflowJobBeenNavigatedAwayFrom = 'SET_HAS_WORKFLOW_JOB_BEEN_NAVIGATED_AWAY_FROM';
  public static readonly SetIsWorkflowJobProcessed = 'SET_IS_WORKFLOW_JOB_PROCESSED';
}
